export const COLORS = {
  BLACK: '#1a1a1a',
  WHITE: '#ffffff',
  PRIMARY: '#FF99CC',
  SECONDARY: '#FA4244',
  TERTIARY: '#F87C5D',
  QUATERNARY: '#BFE8FE',
  QUINARY: '#495AD4',
  SENARY: '#F3E700',
};

export const BREAKPOINTS = {
  XXS: 400,
  XS: 560,
  S: 768,
  M: 1024,
  D: 1280,
  L: 1440,
  XL: 1680,
  XXL: 1920,
};

export const GLOBAL_VARIABLES = {
  COLORS: COLORS,
  BREAKPOINTS: BREAKPOINTS,
};